export interface FooterQuickLink {
  label: string;
  path: string;
}

/** In-app navigation — replaces landing office columns */
export const FOOTER_QUICK_LINKS: FooterQuickLink[] = [
  { label: 'Home', path: '/' },
  { label: 'CWY Store', path: '/store' },
  { label: 'Appointments', path: '/appointments' },
  { label: 'Messaging', path: '/chat' },
  { label: 'My Account', path: '/dashboard' },
  { label: 'My Crypto Wallet', path: '/profile/wallet' },
];
